<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7.53125 2.34375C7.96272 2.34375 8.3125 2.69353 8.3125 3.125V4.6875H17.6875V3.125C17.6875 2.69353 18.0373 2.34375 18.4688 2.34375C18.9002 2.34375 19.25 2.69353 19.25 3.125V4.6875H20.0312C21.7571 4.6875 23.1562 6.08661 23.1562 7.8125V19.5312C23.1562 21.2571 21.7571 22.6562 20.0312 22.6562H5.96875C4.24286 22.6562 2.84375 21.2571 2.84375 19.5312V7.8125C2.84375 6.08661 4.24286 4.6875 5.96875 4.6875H6.75V3.125C6.75 2.69353 7.09978 2.34375 7.53125 2.34375ZM21.5938 11.7188C21.5938 10.8558 20.8942 10.1562 20.0312 10.1562H5.96875C5.10581 10.1562 4.40625 10.8558 4.40625 11.7188V19.5312C4.40625 20.3942 5.10581 21.0938 5.96875 21.0938H20.0312C20.8942 21.0938 21.5938 20.3942 21.5938 19.5312V11.7188Z"
                :fill="color" 
            />
            <path
                d="M12.7926 11.9547C12.8681 11.7937 13.1317 11.7937 13.2072 11.9547L14.2174 14.1099L16.4714 14.4548C16.6559 14.4829 16.7305 14.7087 16.6007 14.8418L14.9632 16.5228L15.3502 18.8993C15.3814 19.0899 15.1782 19.2288 15.0133 19.137L13 18.0223L10.9868 19.1367C10.8203 19.2294 10.619 19.0877 10.6498 18.8989L11.0369 16.5225L9.39941 14.8415C9.26957 14.7084 9.3435 14.4829 9.52863 14.4544L11.7826 14.1096L12.7926 11.9547Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgCalendarStar',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>